<template>
  <div class="mb-4 row">
    <!-- HEADING -->
    <div v-if="field.component_type.name === 'heading'" class="col">
      <h3>{{ field.data }}</h3>
    </div>

    <!-- TEXT-BLOCK -->
    <div v-else-if="field.component_type.name === 'text-block'" class="col">
      <div class="text-right p-4 float-right"></div>
      <div v-html="field.data"></div>
      <div class="mt-3" v-for="audio in field.audio" :key="'audio-' + audio.id">
        <audio-player :file="audio.url"></audio-player>
      </div>
    </div>

    <!-- AUDIO -->
    <div v-else-if="field.component_type.name === 'audio'" class="col">
      <div style="width:100%; max-width:400px;" v-for="file in field.audio" :key="file.id">
        <audio-player :file="file.url"></audio-player>
      </div>
    </div>

    <!-- IMAGE -->
    <template v-else-if="field.component_type.name === 'image'">
      <div class="col-12 p-3 col-md-4" v-for="file in field.images" :key="'image-' + file.id">
        <img :src="file.url" :alt="file.file_name" class="img-fluid" v-if="!file.srcSet">
        <img :src="file.placeholder" :srcset="file.srcSet" :alt="file.file_name" class="img-fluid" v-if="file.srcSet">
      </div>
    </template>

    <div v-else-if="field.component_type.name === 'video'" class="col-11 col-lg-4">
      <div class="card" v-if="video.id" :key="'video-' + video.id">
        <div class="card-header">Video: {{ video.title }}</div>
        <div class="card-body">
          <div class="embed-responsive embed-responsive-16by9" v-if="showVideo">
            <iframe :src="'//player.vimeo.com/video/' + video.vimeo_id + '?autoplay=1'"></iframe>
          </div>
          <img :src="video.thumbnail_url" class="img-fluid w-100" @click="showVideo = true" :alt="video.title" v-if="!showVideo">
        </div>
      </div>
    </div>

    <!-- FILE -->
    <div v-else-if="field.component_type.name === 'file'" class="col">
      <div v-for="file in field.documents" :key="'file-' + file.id">
        <a :href="file.url" target="_blank" class="btn btn-lg btn-orange mgn">
          {{file.name}}</a>
      </div>
    </div>

    <!--&lt;!&ndash; GALLERY &ndash;&gt;-->
    <!--<div ng-if="field.component_type.name == 'gallery'">-->
    <!--<h4 ng-bind-html="field.data"></h4>-->
    <!--</div>-->

    <!-- DIVIDER -->
    <div v-else-if="field.component_type.name === 'divider'" class="col">
      <div style="height:40px;"></div>
    </div>

    <!-- LEARNING ACTIVITY -->
    <div v-else-if="field.component_type.name === 'learning-activity'" class="col w-auto">
      <div v-if="form.loaded && form.hasCompletedSubmissions" class="text-center">
        <h3 class="bg-success p-3">You have already been marked as satisfactory for this assignment!</h3>
      </div>
      <div v-else-if="form.loaded && form.hasPendingSubmissions" class="text-center">
        <h3 class="bg-warning p-3">You have already have a pending assignment awaiting grading!</h3>
      </div>
      <template v-else>
        <div v-if="form.loaded && !form.submitted">
          <form-viewer :schema="form.schema" v-model="form.data" :form-id="form.id" :on-submit="submitForm"></form-viewer>
        </div>
        <loading-spinner :loading="!form.loaded"></loading-spinner>
        <div v-if="form.submitted" class="text-center">
          <h3 class="bg-info p-3">Your assignment has been submitted!</h3>
        </div>
      </template>
    </div>

    <div v-else>
      {{ field }}
    </div>
  </div>
</template>

<script>
import AudioPlayer from './AudioPlayer';
import Submissions from '../mixins/Submissions';
import FormViewer from './FormViewer/FormViewer';

export default {
  name: 'CourseViewer',
  components: {FormViewer, AudioPlayer},
  mixins: [Submissions],
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      video: {
        id: 0,
        thumbnail_url: ''
      },
      showVideo: false
    };
  },
  methods: {
    loadVideo (id) {
      this.axios.get('/video_library/' + id).then(rsp => {
        this.video = rsp.data;
      });
    }
  },
  mounted () {
    if (this.field.component_type && this.field.component_type.name === 'learning-activity') {
      this.loadForm(this.field.data);
    }
    if (this.field.component_type && this.field.component_type.name === 'video') {
      this.loadVideo(this.field.data);
    }
  }
};
</script>

<style scoped>

</style>
